export default __webpack_public_path__ + "static/media/nexcal.46e1da43.png";